import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";
import { pdfStyles, BRAND_COLORS } from "../../BrandedReport/reactPdfStyles";

const STATUS_COLORS = {
  paid: "#29A36A",
  overdue: "#DC2626",
  unpaid: "#F59E0B",
  pending: "#7C8AA5",
  draft: "#94A3B8",
  sent: "#3B82F6",
  recurring: "#8B5CF6",
  default: "#9CA3AF",
};

const styles = StyleSheet.create({
  heroCard: {
    borderWidth: 1,
    borderColor: "#E7DED1",
    borderRadius: 18,
    padding: 18,
    marginBottom: 14,
    backgroundColor: "#FFFDF8",
  },
  heroTop: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 16,
  },
  heroTitleWrap: {
    maxWidth: "72%",
  },
  eyebrow: {
    fontSize: 8,
    textTransform: "uppercase",
    color: "#8D7F6A",
    letterSpacing: 0.8,
    marginBottom: 4,
    fontWeight: "bold",
  },
  heroTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#1F2937",
    marginBottom: 4,
  },
  heroSub: {
    fontSize: 10,
    color: "#6B7280",
    lineHeight: 1.4,
  },
  reportStamp: {
    alignItems: "flex-end",
    maxWidth: "26%",
  },
  reportStampValue: {
    fontSize: 13,
    fontWeight: "bold",
    color: "#1F2937",
    marginBottom: 3,
    textAlign: "right",
  },
  reportStampLabel: {
    fontSize: 8,
    color: "#8D7F6A",
    textTransform: "uppercase",
    letterSpacing: 0.6,
    textAlign: "right",
  },
  kpiGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginHorizontal: -5,
    marginBottom: 10,
  },
  kpiCard: {
    width: "25%",
    paddingHorizontal: 5,
    marginBottom: 10,
  },
  kpiInner: {
    borderWidth: 1,
    borderColor: "#E9E2D7",
    borderRadius: 14,
    padding: 11,
    minHeight: 72,
    backgroundColor: BRAND_COLORS.white,
  },
  kpiLabel: {
    fontSize: 8,
    textTransform: "uppercase",
    color: "#8B8B8B",
    letterSpacing: 0.5,
    marginBottom: 5,
    fontWeight: "bold",
  },
  kpiValue: {
    fontSize: 15,
    fontWeight: "bold",
    color: "#202939",
    marginBottom: 3,
  },
  kpiHint: {
    fontSize: 8,
    color: "#71717A",
    lineHeight: 1.3,
  },
  insightGrid: {
    flexDirection: "row",
    marginHorizontal: -6,
  },
  insightColumn: {
    width: "50%",
    paddingHorizontal: 6,
  },
  insightCard: {
    borderWidth: 1,
    borderColor: "#E9E2D7",
    borderRadius: 14,
    padding: 12,
    minHeight: 170,
    backgroundColor: BRAND_COLORS.white,
  },
  insightTitle: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#374151",
    textTransform: "uppercase",
    letterSpacing: 0.6,
    marginBottom: 10,
  },
  chartRow: {
    marginBottom: 10,
  },
  chartLabelRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  chartLabel: {
    fontSize: 9,
    color: "#374151",
    fontWeight: "medium",
  },
  chartValue: {
    fontSize: 9,
    color: "#6B7280",
  },
  chartTrack: {
    width: "100%",
    height: 9,
    borderRadius: 999,
    backgroundColor: "#F1ECE3",
    overflow: "hidden",
  },
  chartFill: {
    height: 9,
    borderRadius: 999,
  },
  trendGrid: {
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "space-between",
    height: 110,
    paddingTop: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#EEE7DB",
    marginBottom: 8,
  },
  trendColumn: {
    width: "15%",
    alignItems: "center",
  },
  trendBarWrap: {
    height: 76,
    width: "70%",
    justifyContent: "flex-end",
    marginBottom: 6,
  },
  trendBar: {
    width: "100%",
    backgroundColor: "#F2B643",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    minHeight: 4,
  },
  trendMonth: {
    fontSize: 8,
    color: "#6B7280",
    marginBottom: 2,
  },
  trendAmount: {
    fontSize: 7,
    color: "#374151",
  },
  transactionHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  transactionTitle: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#1F2937",
  },
  transactionSub: {
    fontSize: 9,
    color: "#6B7280",
    marginTop: 2,
  },
  transactionCountPill: {
    borderRadius: 999,
    paddingVertical: 5,
    paddingHorizontal: 10,
    backgroundColor: "#F8EDC9",
  },
  transactionCountText: {
    fontSize: 8,
    color: "#8A5A00",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: 0.6,
  },
  transactionTable: {
    display: "table",
    width: "100%",
    borderWidth: 0.5,
    borderColor: "#E2D8C8",
    borderRadius: 8,
    overflow: "hidden",
  },
  transactionRow: {
    flexDirection: "row",
    borderBottomWidth: 0.5,
    borderBottomColor: "#E2D8C8",
    alignItems: "stretch",
  },
  transactionHeaderCell: {
    padding: "6px 7px",
    fontSize: 6.5,
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: 0.3,
    backgroundColor: "#F5F1E9",
    borderRightWidth: 0.5,
    borderRightColor: "#E2D8C8",
    color: "#6B7280",
  },
  transactionCell: {
    padding: "6px 7px",
    fontSize: 8,
    borderRightWidth: 0.5,
    borderRightColor: "#E2D8C8",
    color: "#1F2937",
    justifyContent: "center",
  },
  invoiceCell: {
    fontSize: 8,
    fontWeight: "bold",
    marginBottom: 2,
  },
  invoiceMeta: {
    fontSize: 6.5,
    color: "#6B7280",
  },
  customerName: {
    fontSize: 8,
    fontWeight: "bold",
    marginBottom: 2,
  },
  customerMeta: {
    fontSize: 6.5,
    color: "#6B7280",
  },
  statusPill: {
    borderRadius: 999,
    paddingVertical: 4,
    paddingHorizontal: 7,
    alignSelf: "flex-start",
  },
  statusText: {
    fontSize: 6.5,
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: 0.4,
  },
  amountValue: {
    fontSize: 8.5,
    fontWeight: "bold",
  },
  sectionNote: {
    fontSize: 8,
    color: "#6B7280",
    lineHeight: 1.4,
  },
});

const normalizeStatus = (value) => (value || "unknown").toString().trim().toLowerCase();

const currency = (value) => {
  const numericValue = Number.parseFloat(value || 0);
  return `$${numericValue.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const formatDate = (value) => {
  if (!value) return "—";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("MMM DD, YYYY") : "—";
};

const getInvoiceDate = (item) => item?.invoiceCreatedDate || item?.createdAt || item?.invoiceDate;

const resolveCustomerName = (item) =>
  item?.consumer?.name ||
  item?.customerName ||
  item?.name ||
  item?.consumer?.email ||
  (typeof item?.consumer === "string" ? item.consumer : null) ||
  "Unknown customer";

const resolveCustomerEmail = (item) =>
  item?.consumer?.email || item?.email || item?.customerEmail || "—";

const resolveCustomerId = (item) =>
  item?.consumer?.consumerId || item?.consumerId || item?.customerId || "No ID";

const resolveStatusTone = (status) => {
  const normalized = normalizeStatus(status);
  const color = STATUS_COLORS[normalized] || STATUS_COLORS.default;

  return {
    bg: `${color}22`,
    fg: color,
    label: normalized === "unknown" ? "Unknown" : normalized,
  };
};

const resolveCompanyName = (facilityName) => facilityName || "Business";

const chunk = (items, size) => {
  const chunks = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
};

const paginateTransactions = (items, preferredSize = 28, minLastPageSize = 8) => {
  const pages = chunk(items, preferredSize);
  if (pages.length <= 1) return pages;

  const lastPage = pages[pages.length - 1];
  const previousPage = pages[pages.length - 2];

  if (lastPage.length > 0 && lastPage.length < minLastPageSize) {
    pages[pages.length - 2] = [...previousPage, ...lastPage];
    pages.pop();
  }

  return pages;
};

const getTrendData = (billingData) => {
  const grouped = billingData.reduce((acc, item) => {
    const sourceDate = getInvoiceDate(item) || item?.invoiceDueDate;
    const parsed = moment(sourceDate);
    if (!parsed.isValid()) return acc;
    const key = parsed.format("YYYY-MM");
    if (!acc[key]) {
      acc[key] = {
        label: parsed.format("MMM YY"),
        amount: 0,
      };
    }
    acc[key].amount += Number.parseFloat(item?.totalAmount || 0);
    return acc;
  }, {});

  const ordered = Object.entries(grouped)
    .sort(([a], [b]) => a.localeCompare(b))
    .slice(-6)
    .map(([, value]) => value);

  if (!ordered.length) {
    return [{ label: "No Data", amount: 0 }];
  }

  return ordered;
};

const BillingInvoicePDF = ({ billingData = [], facilityName, facilityPhoto, reportType }) => {
  if (!billingData?.length) {
    return (
      <Document>
        <Page style={pdfStyles.page}>
          <Text>No data available</Text>
        </Page>
      </Document>
    );
  }

  const facName = resolveCompanyName(facilityName);
  const isRecurring = reportType === "recurringinvoices" || (!reportType && billingData.some((item) => item?.recurring));
  const reportTitle = isRecurring ? "Recurring Invoice Financial Report" : "Customer Sales Financial Report";
  const totalAmount = billingData.reduce(
    (sum, item) => sum + (Number.parseFloat(item?.totalAmount || 0) || 0),
    0
  );
  const paidInvoices = billingData.filter((item) => normalizeStatus(item?.status) === "paid");
  const outstandingInvoices = billingData.filter((item) => normalizeStatus(item?.status) !== "paid");
  const paidAmount = paidInvoices.reduce(
    (sum, item) => sum + (Number.parseFloat(item?.totalAmount || 0) || 0),
    0
  );
  const outstandingAmount = outstandingInvoices.reduce(
    (sum, item) => sum + (Number.parseFloat(item?.totalAmount || 0) || 0),
    0
  );
  const overdueInvoices = billingData.filter((item) => {
    const status = normalizeStatus(item?.status);
    return status !== "paid" && item?.invoiceDueDate && moment(item.invoiceDueDate).isBefore(moment(), "day");
  });
  const recurringCount = billingData.filter((item) => item?.recurring).length;
  const customers = new Set(
    billingData
      .map((item) => resolveCustomerName(item) || resolveCustomerEmail(item))
      .filter(Boolean)
  );
  const collectionRate = totalAmount > 0 ? Math.round((paidAmount / totalAmount) * 100) : 0;
  const statusBuckets = [
    {
      label: "Paid",
      count: paidInvoices.length,
      amount: paidAmount,
      color: STATUS_COLORS.paid,
    },
    {
      label: "Outstanding",
      count: outstandingInvoices.length,
      amount: outstandingAmount,
      color: STATUS_COLORS.unpaid,
    },
    {
      label: "Overdue",
      count: overdueInvoices.length,
      amount: overdueInvoices.reduce(
        (sum, item) => sum + (Number.parseFloat(item?.totalAmount || 0) || 0),
        0
      ),
      color: STATUS_COLORS.overdue,
    },
  ];

  const trendData = getTrendData(billingData);
  const maxTrendAmount = Math.max(...trendData.map((item) => item.amount), 1);
  const detailRows = [...billingData].sort((a, b) => {
    const dateA = new Date(getInvoiceDate(a) || a?.invoiceDueDate || 0).getTime();
    const dateB = new Date(getInvoiceDate(b) || b?.invoiceDueDate || 0).getTime();
    return dateB - dateA;
  });
  const transactionPages = paginateTransactions(detailRows, 28, 8);

  return (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <View style={styles.heroCard}>
          <View style={styles.heroTop}>
            <View style={styles.heroTitleWrap}>
              <Text style={styles.eyebrow}>Financial Overview</Text>
              <Text style={styles.heroTitle}>{reportTitle}</Text>
              <Text style={styles.heroSub}>
                {facName} · Generated {moment().format("MMMM DD, YYYY")}
              </Text>
            </View>
            <View style={styles.reportStamp}>
              <Text style={styles.reportStampValue}>{billingData.length} Invoices</Text>
              <Text style={styles.reportStampLabel}>
                {isRecurring ? "Recurring + Standard Snapshot" : "Standard Invoice Snapshot"}
              </Text>
            </View>
          </View>

          <View style={styles.kpiGrid}>
            <View style={styles.kpiCard}>
              <View style={styles.kpiInner}>
                <Text style={styles.kpiLabel}>Total Billed</Text>
                <Text style={styles.kpiValue}>{currency(totalAmount)}</Text>
                <Text style={styles.kpiHint}>Gross invoice value in the selected report period.</Text>
              </View>
            </View>
            <View style={styles.kpiCard}>
              <View style={styles.kpiInner}>
                <Text style={styles.kpiLabel}>Collected</Text>
                <Text style={styles.kpiValue}>{currency(paidAmount)}</Text>
                <Text style={styles.kpiHint}>{paidInvoices.length} invoices fully paid.</Text>
              </View>
            </View>
            <View style={styles.kpiCard}>
              <View style={styles.kpiInner}>
                <Text style={styles.kpiLabel}>Outstanding</Text>
                <Text style={styles.kpiValue}>{currency(outstandingAmount)}</Text>
                <Text style={styles.kpiHint}>{outstandingInvoices.length} invoices still open.</Text>
              </View>
            </View>
            <View style={styles.kpiCard}>
              <View style={styles.kpiInner}>
                <Text style={styles.kpiLabel}>Collection Rate</Text>
                <Text style={styles.kpiValue}>{collectionRate}%</Text>
                <Text style={styles.kpiHint}>
                  {customers.size} customer{customers.size === 1 ? "" : "s"} represented in this report.
                </Text>
              </View>
            </View>
            <View style={styles.kpiCard}>
              <View style={styles.kpiInner}>
                <Text style={styles.kpiLabel}>Overdue Exposure</Text>
                <Text style={styles.kpiValue}>{currency(
                  overdueInvoices.reduce(
                    (sum, item) => sum + (Number.parseFloat(item?.totalAmount || 0) || 0),
                    0
                  )
                )}</Text>
                <Text style={styles.kpiHint}>{overdueInvoices.length} overdue invoice{overdueInvoices.length === 1 ? "" : "s"}.</Text>
              </View>
            </View>
            <View style={styles.kpiCard}>
              <View style={styles.kpiInner}>
                <Text style={styles.kpiLabel}>Recurring Invoices</Text>
                <Text style={styles.kpiValue}>{recurringCount}</Text>
                <Text style={styles.kpiHint}>Automatically scheduled invoice records.</Text>
              </View>
            </View>
            <View style={styles.kpiCard}>
              <View style={styles.kpiInner}>
                <Text style={styles.kpiLabel}>Average Invoice</Text>
                <Text style={styles.kpiValue}>
                  {currency(billingData.length ? totalAmount / billingData.length : 0)}
                </Text>
                <Text style={styles.kpiHint}>Average billed amount per invoice.</Text>
              </View>
            </View>
            <View style={styles.kpiCard}>
              <View style={styles.kpiInner}>
                <Text style={styles.kpiLabel}>Report Mix</Text>
                <Text style={styles.kpiValue}>{isRecurring ? "Hybrid" : "Standard"}</Text>
                <Text style={styles.kpiHint}>
                  {isRecurring ? "Includes recurring invoice activity." : "Focused on standard invoice activity."}
                </Text>
              </View>
            </View>
          </View>

          <View style={styles.insightGrid}>
            <View style={styles.insightColumn}>
              <View style={styles.insightCard}>
                <Text style={styles.insightTitle}>Status Distribution</Text>
                {statusBuckets.map((bucket) => {
                  const width = totalAmount > 0 ? Math.max((bucket.amount / totalAmount) * 100, bucket.count ? 8 : 0) : 0;
                  return (
                    <View key={bucket.label} style={styles.chartRow}>
                      <View style={styles.chartLabelRow}>
                        <Text style={styles.chartLabel}>{bucket.label}</Text>
                        <Text style={styles.chartValue}>
                          {currency(bucket.amount)} · {bucket.count}
                        </Text>
                      </View>
                      <View style={styles.chartTrack}>
                        <View style={[styles.chartFill, { width: `${Math.min(width, 100)}%`, backgroundColor: bucket.color }]} />
                      </View>
                    </View>
                  );
                })}
                <Text style={styles.sectionNote}>
                  This overview emphasizes collected revenue, remaining receivables, and overdue exposure so the report is useful for both finance review and follow-up prioritization.
                </Text>
              </View>
            </View>
            <View style={styles.insightColumn}>
              <View style={styles.insightCard}>
                <Text style={styles.insightTitle}>Billing Trend</Text>
                <View style={styles.trendGrid}>
                  {trendData.map((item) => (
                    <View key={item.label} style={styles.trendColumn}>
                      <View style={styles.trendBarWrap}>
                        <View
                          style={[
                            styles.trendBar,
                            { height: `${Math.max((item.amount / maxTrendAmount) * 100, item.amount ? 6 : 4)}%` },
                          ]}
                        />
                      </View>
                      <Text style={styles.trendMonth}>{item.label}</Text>
                      <Text style={styles.trendAmount}>{currency(item.amount)}</Text>
                    </View>
                  ))}
                </View>
                <Text style={styles.sectionNote}>
                  Monthly trend is derived from invoice creation dates in the returned data. It gives a quick sense of invoice volume movement without making the first page feel overloaded.
                </Text>
              </View>
            </View>
          </View>
        </View>

        <View style={pdfStyles.footer} fixed>
          <Text style={pdfStyles.footerText}>
            {facName} · Financial Report — Confidential · Report generated from www.ogiso.io
          </Text>
          <Text
            style={pdfStyles.footerText}
            render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
          />
        </View>
      </Page>

      {transactionPages.map((rows, pageIndex) => (
        <Page key={`transactions-${pageIndex}`} size="A4" orientation="landscape" style={pdfStyles.page}>
          <View style={styles.transactionHeader}>
            <View>
              <Text style={styles.transactionTitle}>Transaction Detail</Text>
              <Text style={styles.transactionSub}>
                {facName} · {reportTitle} · {moment().format("MMMM DD, YYYY")}
              </Text>
            </View>
            <View style={styles.transactionCountPill}>
              <Text style={styles.transactionCountText}>
                Page {pageIndex + 1} · {rows.length} transactions
              </Text>
            </View>
          </View>

          <View style={styles.transactionTable}>
            <View style={styles.transactionRow}>
              <Text style={[styles.transactionHeaderCell, { width: "11%" }]}>Invoice #</Text>
              <Text style={[styles.transactionHeaderCell, { width: "20%" }]}>Customer / Title</Text>
              <Text style={[styles.transactionHeaderCell, { width: "11%" }]}>Invoice Date</Text>
              <Text style={[styles.transactionHeaderCell, { width: "11%" }]}>Due Date</Text>
              <Text style={[styles.transactionHeaderCell, { width: "10%" }]}>Amount</Text>
              <Text style={[styles.transactionHeaderCell, { width: "10%" }]}>Status</Text>
              <Text style={[styles.transactionHeaderCell, { width: "12%" }]}>Recurring</Text>
              <Text style={[styles.transactionHeaderCell, { width: "15%", borderRightWidth: 0 }]}>Customer Contact</Text>
            </View>

            {rows.map((item, index) => {
              const statusTone = resolveStatusTone(item?.status);
              const rowBg = index % 2 === 1 ? "#FCFAF6" : "#FFFFFF";
              return (
                <View key={`${item?._id || item?.invoiceNumber || index}`} style={[styles.transactionRow, { backgroundColor: rowBg }]}>
                  <View style={[styles.transactionCell, { width: "11%" }]}>
                    <Text style={styles.invoiceCell}>{item?.invoiceNumber || "—"}</Text>
                    <Text style={styles.invoiceMeta}>{resolveCustomerId(item)}</Text>
                  </View>
                  <View style={[styles.transactionCell, { width: "20%" }]}>
                    <Text style={styles.customerName}>{resolveCustomerName(item)}</Text>
                    <Text style={styles.customerMeta}>{item?.invoiceTitle || "Untitled invoice"}</Text>
                  </View>
                  <View style={[styles.transactionCell, { width: "11%" }]}>
                    <Text>{formatDate(getInvoiceDate(item))}</Text>
                  </View>
                  <View style={[styles.transactionCell, { width: "11%" }]}>
                    <Text>{formatDate(item?.invoiceDueDate)}</Text>
                  </View>
                  <View style={[styles.transactionCell, { width: "10%" }]}>
                    <Text style={styles.amountValue}>{currency(item?.totalAmount)}</Text>
                  </View>
                  <View style={[styles.transactionCell, { width: "10%" }]}>
                    <View style={[styles.statusPill, { backgroundColor: statusTone.bg }]}>
                      <Text style={[styles.statusText, { color: statusTone.fg }]}>{statusTone.label}</Text>
                    </View>
                  </View>
                  <View style={[styles.transactionCell, { width: "12%" }]}>
                    <Text>{item?.recurring ? "Yes" : "No"}</Text>
                    <Text style={styles.invoiceMeta}>
                      {item?.recurring ? `${formatDate(item?.recurringDate)} · ${item?.Frequency || "—"}` : "—"}
                    </Text>
                  </View>
                  <View style={[styles.transactionCell, { width: "15%", borderRightWidth: 0 }]}>
                    <Text>{resolveCustomerEmail(item)}</Text>
                  </View>
                </View>
              );
            })}
          </View>

          <View style={pdfStyles.footer} fixed>
            <Text style={pdfStyles.footerText}>
              {facName} · Financial Report — Confidential · Report generated from www.ogiso.io
            </Text>
            <Text
              style={pdfStyles.footerText}
              render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
            />
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default BillingInvoicePDF;
